import React, { Component, createRef } from "react";
import Dropzone from "react-dropzone";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  getAdminUserProfileApi,
  getUserProfileApi,
  updateAdminUserProfileApi,
  updateUserProfileApi,
  baseUrl,
} from "api";
import { withTranslation } from "react-i18next";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      selectedFiles: [],
      user: null,
      adminUser: null,
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
  }

  async componentDidMount() {
    if (JSON.parse(localStorage.getItem("authUser")).id.includes("ADMIN")) {
      const user = await getAdminUserProfileApi();
      console.log(user);
      this.setState({
        adminUser: user.data,
        selectedFiles: user.data.photo
          ? [
              {
                preview: `${baseUrl}/uploads/${user.data.photo}`,
              },
            ]
          : [],
      });
    } else {
      const user = await getUserProfileApi();
      console.log(user);
      this.setState({
        user: user.data,
        selectedFiles:
          user.data.photo != null
            ? [
                {
                  preview: `${baseUrl}/uploads/${user.data.photo}`,
                },
              ]
            : [],
      });
    }
  }
  async handleSubmit(e, values) {
    e.preventDefault();
    let formdata = new FormData();
    Object.keys(values).forEach(x => formdata.append(x, values[x]));
    if (this.state.selectedFiles.length) {
      formdata.delete("photo");
      formdata.append("photo", this.state.selectedFiles[0]);
    }
    if (JSON.parse(localStorage.getItem("authUser")).id.includes("ADMIN")) {
      const data = await updateAdminUserProfileApi(formdata);
    } else {
      formdata.delete("role");
      formdata.delete("id");
      const data = await updateUserProfileApi(formdata);
    }
  }

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ selectedFiles: files });
  };

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "add party";
    const { validation } = this.state;
    return JSON.parse(localStorage.getItem("authUser")).id.includes("ADMIN") ? (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Admin Profile" />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div>
                      <h4 className="text-black fw-bold mb-4">Admin Profile</h4>
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={this.state.adminUser}
                      validationSchema={Yup.object().shape({
                        photo: Yup.string()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value => !value || (value && value.size <= 500000)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value &&
                                ["jpg", "jpeg", "png"].includes(value.type))
                          ),
                        name: Yup.string().required("Please Enter Your Name"),
                        id: Yup.string().required(
                          "Please Enter Your Employee Code"
                        ),
                        addressLine1: Yup.string().required(
                          "Please Enter Your Address"
                        ),
                        addressLine2: Yup.string().required(
                          "Please Enter Your Address"
                        ),
                        city: Yup.string().required("Please Enter Your city"),
                        state: Yup.string().required("Please Enter Your state"),
                        mobileNo1: Yup.string().required(
                          "Please Enter Your Mobile Number"
                        ),
                        mobileNo2: Yup.string().required(
                          "Please Enter Your Mobile Number"
                        ),
                        email: Yup.string().required("Please Enter Your email"),
                        notes: Yup.string().required("This value is required"),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="mb-3 row">
                              <label
                                htmlFor="example-number-input"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Photo")}
                                </h5>
                              </label>
                              <div className="col-md-10">
                                <Dropzone
                                  onDrop={acceptedFiles =>
                                    this.handleAcceptedFiles(acceptedFiles)
                                  }
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <div className="dropzone">
                                      <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="mb-3">
                                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                                        </div>
                                        <h4>
                                          Drop logo here or click to upload.
                                        </h4>
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>
                                <div
                                  className="dropzone-previews mt-3"
                                  id="file-previews"
                                >
                                  {this.state.selectedFiles.map((f, i) => {
                                    return (
                                      <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-file"}
                                      >
                                        <div className="p-2">
                                          <Row className="align-items-center">
                                            <Col className="col-auto">
                                              <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={f.preview}
                                              />
                                            </Col>
                                            <Col>
                                              <Link
                                                to="#"
                                                className="text-muted font-weight-bold"
                                              >
                                                {f.name}
                                              </Link>
                                              <p className="mb-0">
                                                <strong>
                                                  {f.formattedSize}
                                                </strong>
                                              </p>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Card>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="name"
                                  placeholder="Admin"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Employee Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="id"
                                  placeholder="ADM00001"
                                />
                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="email"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Email ID")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="email"
                                  placeholder="xyzdiamond123@gmail.com"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Mobile no.1")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo1 && touched.mobileNo1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobileNo1"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Mobile no.2")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo2 && touched.mobileNo2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobileNo2"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 1")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine1 && touched.addressLine1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="addressLine1"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 2")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine2 && touched.addressLine2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="addressLine2"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="city"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("City")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.city && touched.city
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="city"
                                  placeholder="City"
                                />
                                <ErrorMessage
                                  name="city"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="state"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("State")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.state && touched.state
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="state"
                                  as="select"
                                >
                                  <option value="" disabled>select</option>
                                  <option value="1">Gujarat</option>
                                  <option value="2">Maharashtra</option>
                                  <option value="3">Tamil Nadu</option>
                                  <option value="4">Uttar Pradesh</option>
                                  <option value="5">West Bengal</option>
                                  <option value="6">Karnataka</option>
                                  <option value="7">Rajasthan</option>
                                  <option value="8">Andhra Pradesh</option>
                                  <option value="9">Madhya Pradesh</option>
                                </Field>
                                <ErrorMessage
                                  name="state"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="notes"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Admin Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.notes && touched.notes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="notes"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="notes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                                onClick={() => this.handleSubmit(event, values)}
                              >
                                Submit
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    ) : (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("My Profile")} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-lg-flex d-block text-center text-lg-start justify-content-between">
                      <div>
                        <h4 className="text-black fw-bold mb-4">
                          {this.props.t("My Profile")}
                        </h4>
                      </div>
                      <div>
                        <h4 className="fw-bold">
                          {this.props.t("Role")}:{" "}
                          <span className="text-black">
                            {this.props.t(this.state.user?.role?.name)}
                          </span>
                        </h4>
                      </div>
                    </div>
                    <Formik
                      enableReinitialize={true}
                      initialValues={this.state.user}
                      validationSchema={Yup.object().shape({
                        photo: Yup.string()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value => !value || (value && value.size <= 500000)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value &&
                                ["jpg", "jpeg", "png"].includes(value.type))
                          ),
                        name: Yup.string().required("Please Enter Your Name"),
                        id: Yup.string().required(
                          "Please Enter Your User Code"
                        ),
                        addressLine1: Yup.string().required(
                          "Please Enter Your Address"
                        ),
                        addressLine2: Yup.string().required(
                          "Please Enter Your Address"
                        ),
                        city: Yup.string().required("Please Enter Your city"),
                        state: Yup.string().required("Please Enter Your state"),
                        mobileNo1: Yup.string().required(
                          "Please Enter Your Mobile Number"
                        ),
                        mobileNo2: Yup.string().required(
                          "Please Enter Your Mobile Number"
                        ),
                        email: Yup.string().required("Please Enter Your email"),
                      })}
                      onSubmit={values => {}}
                    >
                      {({ errors, status, touched, values }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="mb-3 row">
                              <label
                                htmlFor="example-number-input"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Photo")}
                                </h5>
                              </label>
                              <div className="col-md-10">
                                <Dropzone
                                  onDrop={acceptedFiles =>
                                    this.handleAcceptedFiles(acceptedFiles)
                                  }
                                >
                                  {({ getRootProps, getInputProps }) => (
                                    <div className="dropzone">
                                      <div
                                        className="dz-message needsclick"
                                        {...getRootProps()}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="mb-3">
                                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                                        </div>
                                        <h4>
                                          Drop logo here or click to upload.
                                        </h4>
                                      </div>
                                    </div>
                                  )}
                                </Dropzone>
                                <div
                                  className="dropzone-previews mt-3"
                                  id="file-previews"
                                >
                                  {this.state.selectedFiles.map((f, i) => {
                                    return (
                                      <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-file"}
                                      >
                                        <div className="p-2">
                                          <Row className="align-items-center">
                                            <Col className="col-auto">
                                              <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={f.preview}
                                              />
                                            </Col>
                                            <Col>
                                              <Link
                                                to="#"
                                                className="text-muted font-weight-bold"
                                              >
                                                {f.name}
                                              </Link>
                                              <p className="mb-0">
                                                <strong>
                                                  {f.formattedSize}
                                                </strong>
                                              </p>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Card>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5 text-uppercase" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="name"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  readOnly={true}
                                  type="text"
                                  name="id"
                                  placeholder="ADM00001"
                                />
                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="email"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Email ID")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="email"
                                  placeholder="xyzdiamond123@gmail.com"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Mobile no.1")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo1 && touched.mobileNo1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobileNo1"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Mobile no.2")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo2 && touched.mobileNo2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="number" onWheel={(e) => e.target.blur()}
                                  name="mobileNo2"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 1")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine1 && touched.addressLine1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="addressLine1"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 2")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine2 && touched.addressLine2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="addressLine2"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="city"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("City")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.city && touched.city
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="city"
                                  placeholder="City"
                                />
                                <ErrorMessage
                                  name="city"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="state"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("State")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.state && touched.state
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="state"
                                  as="select"
                                >
                                  <option value="" disabled>select</option>
                                  <option value="1">Gujarat</option>
                                  <option value="2">Maharashtra</option>
                                  <option value="3">Tamil Nadu</option>
                                  <option value="4">Uttar Pradesh</option>
                                  <option value="5">West Bengal</option>
                                  <option value="6">Karnataka</option>
                                  <option value="7">Rajasthan</option>
                                  <option value="8">Andhra Pradesh</option>
                                  <option value="9">Madhya Pradesh</option>
                                </Field>
                                <ErrorMessage
                                  name="state"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-end">
                              <Button
                                color="primary"
                                className="fs-4 px-5"
                                type="submit"
                                onClick={() => this.handleSubmit(event, values)}
                              >
                                Save
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(Profile);
